import styled from "styled-components/macro";

export default styled.div`
    padding: 30px 80px;

    @media only screen and (max-width: 480px) {
        padding: 20px;
    }
`;